













import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { BuildingsApi, Room } from 'performo-api';
import { mapGetters } from 'vuex';

@Component({
  components: {},
  computed: mapGetters({
    buildingsApi: 'buildingsApi'
  })
})
export default class Location2DisplayComponent extends Vue {
  @Prop({ required: false, default: 'Room' })
  private label!: string;

  @Prop({ required: true, type: String })
  private buildingCode!: string;

  @Prop({ required: true, type: String })
  private roomCode!: string;

  private buildingsApi!: BuildingsApi;

  private room!: Room;

  data() {
    return {
      room: undefined
    };
  }

  private mounted() {
    if (this.roomCode) {
      this.loadBuildingDetails(this.roomCode);
    }
  }

  @Watch('roomCode')
  buildingCodeWatcher(val: string) {
    this.loadBuildingDetails(val);
  }

  loadBuildingDetails(val: string) {
    // do a one-off building query and try that
    this.buildingsApi
      .queryRooms({ buildingCode: this.buildingCode, roomCode: val })
      .then((rooms) => {
        if (rooms && rooms.data && rooms.data.length === 1) {
          this.room = rooms.data[0];
        }
      })
      .catch(() => {
        /**? */
      });
  }
}
